import { Component, ViewEncapsulation } from '@angular/core';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'now-wbsuche-lib-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss', './global-print-styles.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [HeaderComponent, FooterComponent]
})
export class MainLayoutComponent {
  /**
   * Sprunglink zur Verbesserung der Barrierefreiheit.
   */
  goTo(location: string, $event: MouseEvent): void {
    $event.preventDefault();
    // Zurücksetzen der Location, da sonst der Einsprung nur einmal ausgeführt werden kann.
    window.location.hash = '';
    window.location.hash = location;
  }
}
